import * as React from 'react';

import {
  DialogContent,
  DialogFooter,
  DialogTrigger,
  DialogOverlay,
  DialogTitle,
  cn,
} from '../..';

export type ConsoleDrawerProps = {
  title: React.ReactNode;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  content: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  isLoading?: boolean;
  position?: 'left' | 'right';
};

export const ConsoleDrawer = ({
  isOpen,
  onOpenChange,
  title,
  content,
  footer,
  position = 'right',
  className,
  isLoading,
}: ConsoleDrawerProps) => (
  <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
    <DialogOverlay className={cn('@ConsoleDrawer', className)}>
      <DialogContent
        position={position}
        isLoading={isLoading}
        dialogClassName="flex flex-col p-0"
      >
        <div className="space-y-1.5 border-b border-neutral/10 bg-neutral/5 p-4 text-center sm:text-left">
          <DialogTitle className="text-lg font-semibold">{title}</DialogTitle>
        </div>

        <div className="no-scrollbar min-w-[600px] flex-1 overflow-y-auto px-5 py-4">
          {content}
        </div>

        {footer && (
          <DialogFooter className="flex-row justify-end gap-2 border-t border-neutral/10 bg-neutral/5 p-4 shadow-[0_-4px_14px_0_rgba(7,20,41,0.05)]">
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </DialogOverlay>
  </DialogTrigger>
);
